import type { Space } from '@mail/cross-sizes-utils';
import React, { type ReactNode } from 'react';
import { clamp } from 'reactApp/utils/mathHelpers';

import { TooltipContext } from './FlexibleQuota.constants';

const formatter = new Intl.NumberFormat('ru');

export function getStepByValue(value?: number) {
    return (value || 0) >= 1000 ? 100 : 10;
}

export function spaceFromGb(gb: number): Space {
    return {
        original: gb * 1024 * 1024 * 1024,
        space: gb,
        units: 'ГБ',
        value: `${formatter.format(gb)} ГБ`,
    };
}

const marksInfo: { value: number; context: TooltipContext }[] = [
    { value: 0, context: TooltipContext.INIT },
    { value: 1000, context: TooltipContext.PRIVATE },
    { value: 2000, context: TooltipContext.STUDY },
    { value: 3000, context: TooltipContext.BUSINESS },
    { value: 4000, context: TooltipContext.PRO },
];

export const marksValue = marksInfo.map(({ value }) => value);

export const getContext = (value: number, forceInit: boolean) => {
    const context = marksInfo.find((item) => value <= item.value)?.context;
    if (!context || forceInit) {
        return TooltipContext.INIT;
    }
    return context;
};

export const normalizeValue = (value = 0, min?: number, max?: number) => {
    const clamped = clamp(value, min, max);
    const step = getStepByValue(clamped);
    return Math.round(clamped / step) * step;
};

export const validateValue = (value = 0, step = 0, min = 0, max = 0): [ReactNode, string | null] => {
    if (value < min) {
        return [<>Минимум&nbsp;&mdash; {formatter.format(min)}&nbsp;ГБ</>, 'min'];
    }
    if (value > max) {
        return [<>Максимум&nbsp;&mdash; {formatter.format(max)}&nbsp;ГБ</>, 'max'];
    }
    if (value % step !== 0) {
        return [<>Число должно делиться на&nbsp;{formatter.format(step)} без остатка</>, `step${step}`];
    }
    return [null, null];
};
